import { render, staticRenderFns } from "./BaseDateOfBirthInput.vue?vue&type=template&id=06038928"
import script from "./BaseDateOfBirthInput.vue?vue&type=script&lang=js"
export * from "./BaseDateOfBirthInput.vue?vue&type=script&lang=js"
import style0 from "./BaseDateOfBirthInput.vue?vue&type=style&index=0&id=06038928&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports